import React from "react";
import InfoEdit from "../../components/InfoEdit/InfoEdit";

const Informations = props => {
	const style = {
		display: "grid",
		gridTemplateColumns: "repeat(1,1fr)",
		gridGap: "10px",
		gridAutoRows: "minmax(100px,auto)"
	};

	return (
		<div>
			<h2 style={{ width: "100%", textAlign: "left" }}>Información Útil</h2>

			<div style={style}>
				{props.informations.map(l => (
					<InfoEdit
						id={l.idInformacion}
						title={l.titulo}
						info={l.descripcion}
						handleSaveButton={props.handleSaveButton}
						token={props.token}
					/>
				))}
			</div>
		</div>
	);
};

export default Informations;
